import moment from 'moment'
import { DateRangePicker, Form } from 'components/common'

interface SalesPeriodProps {
  periodForSale?:
    | [string | moment.Moment | null, string | moment.Moment | null]
    | null
  loading?: boolean
}

export const ProductSalePeriod = ({
  periodForSale,
  loading,
}: SalesPeriodProps): JSX.Element => {
  return (
    <>
      <div style={{ width: '50%', paddingTop: '10px' }}>
        <Form.Item
          name="periodForSale"
          initialValue={!loading && periodForSale ? periodForSale : undefined}
        >
          <DateRangePicker picker="date" format="M月D日" />
        </Form.Item>
      </div>
    </>
  )
}
